import { createRolesHooks } from '@gasbi/shared/common/features/roles';

import {
  mainOrganizationApi,
  useGetCachedRoleByIdSelector as useGetCachedMainOrgRoleByIdSelector,
} from '../mainOrganization/mainOrganizationApi';
import {
  organizationsApi,
  useGetCachedRoleByIdSelector as useGetCachedOrgRoleByIdSelector,
} from '../organizations/organizationsApi';
import { isRootRole } from './utils';

export const {
  useGetSystemRolesQuery,
  useGetRolesQuery,
  useGetRoleByIdQuery,
  useSaveRoleMutation,
  useAssignRoleMutation,
  useSuspendRoleMutation,
  useGetCachedRoleByIdSelector,
} = createRolesHooks(
  organizationsApi,
  mainOrganizationApi,
  useGetCachedOrgRoleByIdSelector,
  useGetCachedMainOrgRoleByIdSelector,
  isRootRole,
);
